// src/constants/timezones.ts
export interface TimezoneOption {
    value: string;
    label: string;
}

export const TIMEZONES: TimezoneOption[] = [
    { value: "Africa/Cairo", label: "Africa/Cairo" },
    { value: "Africa/Casablanca", label: "Africa/Casablanca" },
    { value: "Africa/Johannesburg", label: "Africa/Johannesburg" },
    { value: "Africa/Lagos", label: "Africa/Lagos" },
    { value: "Africa/Nairobi", label: "Africa/Nairobi" },
    { value: "America/Anchorage", label: "America/Anchorage" },
    { value: "America/Bogota", label: "America/Bogota" },
    { value: "America/Buenos_Aires", label: "America/Buenos_Aires" },
    { value: "America/Chicago", label: "America/Chicago" },
    { value: "America/Edmonton", label: "America/Edmonton" },
    { value: "America/Halifax", label: "America/Halifax" },
    { value: "America/Lima", label: "America/Lima" },
    { value: "America/Mexico_City", label: "America/Mexico_City" },
    { value: "America/New_York", label: "America/New_York" },
    { value: "America/Phoenix", label: "America/Phoenix" },
    { value: "America/Santiago", label: "America/Santiago" },
    { value: "America/Sao_Paulo", label: "America/Sao_Paulo" },
    { value: "America/St_Johns", label: "America/St_Johns" },
    { value: "America/Tijuana", label: "America/Tijuana" },
    { value: "America/Toronto", label: "America/Toronto" },
    { value: "America/Vancouver", label: "America/Vancouver" },
    { value: "America/Winnipeg", label: "America/Winnipeg" },
    { value: "America/Denver", label: "America/Denver" },
    { value: "America/Los_Angeles", label: "America/Los_Angeles" },
    { value: "Asia/Almaty", label: "Asia/Almaty" },
    { value: "Asia/Bangkok", label: "Asia/Bangkok" },
    { value: "Asia/Colombo", label: "Asia/Colombo" },
    { value: "Asia/Dhaka", label: "Asia/Dhaka" },
    { value: "Asia/Dubai", label: "Asia/Dubai" },
    { value: "Asia/Hong_Kong", label: "Asia/Hong_Kong" },
    { value: "Asia/Jakarta", label: "Asia/Jakarta" },
    { value: "Asia/Karachi", label: "Asia/Karachi" },
    { value: "Asia/Kathmandu", label: "Asia/Kathmandu" },
    { value: "Asia/Kolkata", label: "Asia/Kolkata" },
    { value: "Asia/Kuala_Lumpur", label: "Asia/Kuala_Lumpur" },
    { value: "Asia/Manila", label: "Asia/Manila" },
    { value: "Asia/Riyadh", label: "Asia/Riyadh" },
    { value: "Asia/Seoul", label: "Asia/Seoul" },
    { value: "Asia/Shanghai", label: "Asia/Shanghai" },
    { value: "Asia/Singapore", label: "Asia/Singapore" },
    { value: "Asia/Taipei", label: "Asia/Taipei" },
    { value: "Asia/Tashkent", label: "Asia/Tashkent" },
    { value: "Asia/Tehran", label: "Asia/Tehran" },
    { value: "Asia/Tokyo", label: "Asia/Tokyo" },
    { value: "Australia/Adelaide", label: "Australia/Adelaide" },
    { value: "Australia/Brisbane", label: "Australia/Brisbane" },
    { value: "Australia/Darwin", label: "Australia/Darwin" },
    { value: "Australia/Melbourne", label: "Australia/Melbourne" },
    { value: "Australia/Perth", label: "Australia/Perth" },
    { value: "Australia/Sydney", label: "Australia/Sydney" },
    { value: "Europe/Amsterdam", label: "Europe/Amsterdam" },
    { value: "Europe/Athens", label: "Europe/Athens" },
    { value: "Europe/Berlin", label: "Europe/Berlin" },
    { value: "Europe/Brussels", label: "Europe/Brussels" },
    { value: "Europe/Bucharest", label: "Europe/Bucharest" },
    { value: "Europe/Budapest", label: "Europe/Budapest" },
    { value: "Europe/Copenhagen", label: "Europe/Copenhagen" },
    { value: "Europe/Dublin", label: "Europe/Dublin" },
    { value: "Europe/Helsinki", label: "Europe/Helsinki" },
    { value: "Europe/Istanbul", label: "Europe/Istanbul" },
    { value: "Europe/Kiev", label: "Europe/Kiev" },
    { value: "Europe/Lisbon", label: "Europe/Lisbon" },
    { value: "Europe/Madrid", label: "Europe/Madrid" },
    { value: "Europe/Moscow", label: "Europe/Moscow" },
    { value: "Europe/Oslo", label: "Europe/Oslo" },
    { value: "Europe/Prague", label: "Europe/Prague" },
    { value: "Europe/Rome", label: "Europe/Rome" },
    { value: "Europe/Stockholm", label: "Europe/Stockholm" },
    { value: "Europe/Vienna", label: "Europe/Vienna" },
    { value: "Europe/Warsaw", label: "Europe/Warsaw" },
    { value: "Europe/Zurich", label: "Europe/Zurich" },
    { value: "Europe/Paris", label: "Europe/Paris" },
    { value: "Europe/London", label: "Europe/London" },
    { value: "IST", label: "IST" },
    { value: "Pacific/Auckland", label: "Pacific/Auckland" },
    { value: "Pacific/Fiji", label: "Pacific/Fiji" },
    { value: "Pacific/Honolulu", label: "Pacific/Honolulu" },
    { value: "UTC", label: "UTC" },
];
